import {
    BetBuilderPickId,
    PickId,
    V1PickId,
    V2OptionMarketPickId,
    V2OptionMarketXCastPickId,
    V2ParticipantPickId,
    V2WinPickId,
} from '../../../../core/picks/pick-id';
import { BetBuilderPickRequestBuilder } from './bet-builder-pick-request.builder';
import { PickRequestBuilder } from './pick-request.builder';
import { V1PickRequestBuilder } from './v1-pick-request.builder';
import { V2OptionMarketPickRequestBuilder, V2OptionMarketXCastPickRequestBuilder } from './v2-option-market-pick-request.builder';
import { V2ParticipantPickRequestBuilder } from './v2-participant-pick-request.builder';

export function getPickRequestBuilder(pickId: PickId): PickRequestBuilder<PickId> {
    switch (pickId.constructor) {
        case V1PickId:
            return new V1PickRequestBuilder();
        case V2ParticipantPickId:
        case V2WinPickId:
            return new V2ParticipantPickRequestBuilder();
        case V2OptionMarketPickId:
            return new V2OptionMarketPickRequestBuilder();
        case V2OptionMarketXCastPickId:
            return new V2OptionMarketXCastPickRequestBuilder();
        case BetBuilderPickId:
            return new BetBuilderPickRequestBuilder();
        default:
            throw new Error(`Missing Pick Builder For Type ${pickId.constructor.name}`);
    }
}
